
export const commonBaseUrl='https://application.amasi.org';
export const ROUTE_BASE_URL='/events/admin';

export const baseUrl = 'https://eventz360.amasi.org'
export const localserver = 'https://eventz360.amasi.org'


